import './JobCard.scss';

import React from 'react';

interface JobCardProps {
  title: string;
  locations: string;
  type: string; 
  url: string;
  experience:string
}

export const JobCard: React.FC<JobCardProps> = ({
  title,
  locations,
  type,
  url,
  experience,
}) => {
  const locationArr = typeof locations === 'string'
    ? locations.split(/;|\n/).map(loc => loc.trim()).filter(Boolean)
    : Array.isArray(locations) ? locations : [];
  const hasMultipleLocations = locationArr.length > 2;
  const locationsLabel = hasMultipleLocations ? 'Multiple Locations' : '';
  return (
    <div className="job-card">
      <a className="job-card__link" href={url}>
        <div className="job-card__header">
          {locationsLabel ? (
            <div className="job-card__locations">{locationsLabel}</div>
          ) : (
            <div className="job-card__location">
              {locationArr.length > 0 ? locationArr.join(' | ') : ''}
            </div>
          )}
        </div>
        <div className="job-card__title">{title}</div>
        <div className="job-card__type">{type} | {experience}</div>
        <div className="cmp-teaser__action-container">
          <div className="job-card__action-link">
            <div className="cmp-button__icon">
              <span className="cmp-button__icon cmp-button__icon--keyboard_arrow_right icon--md" aria-label="View job"></span>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};